module.exports = __webpack_public_path__ + "img/dash-icon1.d3fb53c9.png";